import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { FormCanDeactivate } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/form-can-deactivate";
import { NameValue } from "projects/sepidz-web-framework/src/lib/models/name-value";
import { AuthService, LookupService, ShowToastrService } from "projects/sepidz-web-framework/src/lib/services";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { InvVoucherHeader } from "../../models/inv-voucher-header.model";

@Component({
  selector: "ngx-inv-voucher-modal-list",
  templateUrl: "./inv-voucher-modal-list.component.html",
  styleUrls: ["./inv-voucher-modal-list.component.scss"],
})
export class InvVoucherModalListComponent extends FormCanDeactivate implements OnInit, OnDestroy {
  filterInfo: NameValue[] = [];
  ngUnsubscribe = new Subject<void>();
  apiName: string;
  areaName: string;
  label: string;
  currentVoucher: InvVoucherHeader;
  @Input() currentVoucherKindId: number;
  @Input() dataList: InvVoucherHeader[];
  constructor(
    private authService: AuthService,
    protected translateText: TranslateService,
    private sts: ShowToastrService,
    private lookupservice: LookupService
  ) {
    super();
  }
  ngOnDestroy(): void {
    if (this.ngUnsubscribe) {
      this.ngUnsubscribe.next();
      this.ngUnsubscribe.complete();
    }
    this.filterInfo = undefined;
    this.currentVoucher = undefined;
  }
  get currentFiscalYear() {
    return this.authService.currentFiscalYear;
  }
  ngOnInit() {
    this.lookupservice.getall();
    this.apiName = "InvVoucherHeader";
    this.areaName = "Inventory";
    this.label = "فهرست اسناد";
    if (this.currentVoucherKindId) this.filterInfo.push({ Name: "VoucherKindId", Value: this.currentVoucherKindId, Operator: "eq" });
    if (this.currentFiscalYear) {
      this.filterInfo.push({ Name: "FiscalYearId", Value: this.currentFiscalYear?.Id, Operator: "eq" });
      this.filterInfo.push({ Name: "BranchId", Value: this.authService.currentBranchId, Operator: "eq" });
    } else
      this.authService.currentFiscalYearobsr.pipe(takeUntil(this.ngUnsubscribe)).subscribe((x) => {
        if (x) {
          this.filterInfo.push({ Name: "FiscalYearId", Value: x.Id, Operator: "eq" });
          this.filterInfo.push({ Name: "BranchId", Value: this.authService.currentBranchId, Operator: "eq" });
        }
      });
  }

  onDoubleClick(voucher?: InvVoucherHeader) {
    this.result = voucher;
    this.closeModal();
  }
  cancel() {
    this.result = undefined;
    this.closeModal();
  }
  onRowSelected($event) {
    if ($event) {
      this.currentVoucher = $event;
    }
  }
  submit() {
    if (!this.currentVoucher) this.sts.showDialog("هیچ سندی انتخاب نشده است.", "انتخاب سند");
    else this.onDoubleClick(this.currentVoucher);
  }
}
